const AppRoutes = {
  homepage: '/',
  flights: '/flights',
  hotels: '/hotels',
  vacationpackages: '/vacationpackages',
  vip: '/vip'
} as const

export default AppRoutes
